import React from "react";
import { FormattedMessage } from "react-intl";
import ImportFileImage from "@/images/import-file.svg";

function UploadInstructions(props) {
  return (
    <React.Fragment>
      <img alt="Import File" src={ImportFileImage} />
      <div className={"instructions"}>
        <h4>
          <FormattedMessage
            id="App.Text.HowToUpload"
            defaultMessage={"How to upload file"}
          />
        </h4>
        <p>
          <span>1.</span>
          <span>
            <FormattedMessage
              id="App.Text.DownloadExcelProvided"
              defaultMessage={"Download the excel template provided"}
            />
          </span>
        </p>
        <p>
          <span>2.</span>
          <span>
            <FormattedMessage
              id="App.Text.ImportPopulateExcel"
              defaultMessage={
                "Populate the downloaded excel spreadsheet with details of your people."
              }
            />
          </span>
        </p>
        <p>
          <span>3.</span>
          <span>
            <FormattedMessage
              id="App.Text.ReturnToUpload"
              defaultMessage={"Return to this page and upload the file."}
            />
          </span>
        </p>
        <p className="note">
          <FormattedMessage
            id="App.Text.ImportNote"
            defaultMessage={
              "Note: A phone number or email address is required for successfully adding a person."
            }
          />
        </p>
      </div>
    </React.Fragment>
  );
}

export default UploadInstructions;
